import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import TextField from '@mui/material/TextField';
import React, { useRef, useState, useEffect } from "react";
import { useSession } from "../SessionContext";
import axios from "axios";
import { API_URL } from "../../config";
import { uploads } from "../../config";

const DoctorPhotogalleryForm = () => {
    const { session } = useSession();

    const [data, setData] = useState({});
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedImages, setSelectedImages] = useState([]);
    const fileInputRef = useRef(null);
    //const [images, setImages] = useState([]);
    const [preview, setPreview] = useState("");

    // ✅ FILE CHANGES
    const handleImageChange = (e) => {
        setSelectedImages(Array.from(e.target.files));
        setErrors({});
    };

    // ✅ FORM VALIDATION
    const validate = () => {
        let newErrors = {};

        if (selectedImages.length === 0) {
            newErrors.photogallery = "Please select at least one image";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ✅ SAVE GALLERY IMAGES
    const handleSave = async () => {
        if (!validate()) return;

        try {
            const fd = new FormData();

            selectedImages.forEach((file) => {
                fd.append("photogallery[]", file);
            });

            const response = await fetch(
                `${API_URL}/api-upload-photogallery.php`,
                {
                    method: "POST",
                    credentials: "include",
                    body: fd,
                }
            );

            const result = await response.json();

            if (result.status === "success") {
    console.log("Upload success:", result.images);

    // 1. clear selected images state
    setSelectedImages([]);

    // 2. reset file input UI
    if (fileInputRef.current) {
        fileInputRef.current.value = "";
    }

    // 3. refresh full gallery from server (BEST WAY)
    const res = await axios.get(
        `${API_URL}/api-get-user-details.php`,
        { withCredentials: true }
    );

    const user = res.data.data[0];

    user.photogallery = user.photogallery
        ? user.photogallery.split(",").map(img => img.trim())
        : [];

    setFormData(user);
}

        } catch (err) {
            console.error("Upload error:", err);
        }
    };

    // ✅ GET GALLERY IMAGES
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];

                user.photogallery = user.photogallery
                    ? user.photogallery.split(",").map(img => img.trim())
                    : [];

                setData(user);
                setFormData(user);

                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch(console.log);
    }, []);

    // ✅ REMOVE GALLERY IMAGES
 const deleteImage = async (imgName) => {
    try {
        const res = await fetch(
            `${API_URL}/api-delete-photogallery-images.php`,
            {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    images: imgName,
                }),
            }
        );

        const result = await res.json();

        if (result.status === "success") {
            // ✅ Update UI immediately from API response
            setFormData((prev) => ({
                ...prev,
                photogallery: result.remaining_images || [],
            }));
            alert("Do you really want to delete this image?");
            
        } else {
            alert(result.message);
        }
    } catch (err) {
        console.error("Delete error:", err);
    }
};

    return (
        <div className='bd-right-panel fade-in'>
            <p style={{ display: "none" }}>User ID: {session?.userid} | Category: {session?.ucategory} | Email: {session?.email}</p>

            <div className='comp-details'>
                <div className='logo-box'>
                    <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                    onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = "/images/default-profile-pic.jpg";
                    }} />
                </div>
                <div className='title-box'><VerifiedIcon /> {data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</div>
                <div className='location-box'>
                    <FmdGoodOutlinedIcon />
                    {data?.business_address ? `${data.business_address}, ` : ""}
                    {data?.business_city ? `${data.business_city}, ` : ""}
                    {data?.business_district ? `${data.business_district}, ` : ""}
                    {data?.business_state ? `${data.business_state} - ` : ""}
                    {data?.business_zipcode || ""}
                </div>
            </div>
            <div className='clr'></div>
            <div className='devider'></div>
            <div className='db-form-panel'>
                <div className='heading' style={{ border: "none" }}>
                    <h2 style={{ margin: 0 }}>Photogallery:</h2>
                    <div className='clr'></div>
                </div>
                <div className='db-form-details'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='db-form-row'>
                                <TextField type="file" className="db-textbox" label="Add Gallery Image*" InputLabelProps={{ shrink: true }} inputProps={{ accept: "image/*" }}
                                    onChange={handleImageChange}
                                    error={!!errors.photogallery} helperText={errors.photogallery} ref={fileInputRef} />
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='db-form-row'>
                                <div style={{ textAlign: "center" }}>
                                    <button onClick={handleSave} className="update-btn">
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='gallery-panel'>
                    {formData.photogallery?.map((img, index) => (

                        <div className='gallery-imgbox'>
                            <img key={index} src={`${uploads}/${img}`} className="gallimg" alt={`gallery-${index}`} />
                            <div className='imgdelete-btn' title="Delete"  onClick={() => deleteImage(img)} ><DeleteForeverIcon /></div>
                        </div>
                    ))}

                    
                    <div className='clr'></div>
                </div>
            </div>
        </div>
    )
}

export default DoctorPhotogalleryForm
